import Immutable from 'immutable';
import PropTypes from 'prop-types';
import * as React from 'react';
import { AutoSizer, Grid, ColumnSizer } from 'react-virtualized';
import cn from 'classnames';

import '../../../../styles/IssuesBreakdown.css';
import IssuesCell from './IssuesCell';

export default class IssuesBreakdown extends React.PureComponent {
  constructor(props, context) {
    super(props, context);

    this.state = {
      columnCount: 5,
      height: 300,
      overscanColumnCount: 0,
      overscanRowCount: 10,
      rowHeight: 40,
      rowCount: props.data.length + 1,
      scrollToColumn: undefined,
      scrollToRow: undefined,
      useDynamicRowHeight: false,
    };
  }

  render() {
    const {
      columnCount,
      height,
      overscanColumnCount,
      overscanRowCount,
      rowHeight,
      rowCount,
      scrollToColumn,
      scrollToRow,
      useDynamicRowHeight,
    } = this.state;

    const {
      relationships,
      data,
    } = this.props;

    return (
      <AutoSizer disableHeight>
        {({width}) => (
          <ColumnSizer
            columnMinWidth={100}
            columnCount={columnCount}
            key="GridColumnSizer"
            width={width}>
            {({adjustedWidth, columnWidth, registerChild}) => (
              <div
                style={{
                  height: 50,
                  width: adjustedWidth,
                }}>
                  <Grid
                    cellRenderer={this._cellRenderer}
                    relationships={relationships}
                    data={data}
                    ref={registerChild}
                    className={'temporary'}
                    columnWidth={columnWidth}
                    columnCount={columnCount}
                    height={height}
                    noContentRenderer={this._noContentRenderer}
                    overscanColumnCount={overscanColumnCount}
                    overscanRowCount={overscanRowCount}
                    rowHeight={rowHeight}
                    rowCount={rowCount}
                    scrollToColumn={scrollToColumn}
                    scrollToRow={scrollToRow}
                    width={adjustedWidth}
                  />
                </div>
              )}
            </ColumnSizer>
          )}
        </AutoSizer>
    );
  }

  _cellRenderer = ({columnIndex, key, rowIndex, style}) => {
    if (columnIndex === 0) {
      return this._renderLeftSideCell({columnIndex, key, rowIndex, style});
    } else {
      return this._renderBodyCell({columnIndex, key, rowIndex, style});
    }
  }

  _getColumnWidth = ({index}) => {
    switch (index) {
      case 0:
        return 150;
      default:
        return 100;
    }
  }

  _getDatum = (index) => {
    const { data } = this.props;

    return data[index - 1];
  }

  _getRowClassName = (row) => {
    return row % 2 === 0 ? 'even' : 'issues-odd-row ';
  }

  _noContentRenderer = () => {
    return <div className={'no-cells'}>No cells</div>;
  }

  _renderFirstRow = (column) => {
    switch (column) {
      case 1:
        return 'Total';
      case 2:
        return 'Open';
      case 3:
        return 'Complete';
      case 4:
        return 'Accepted';
      default:
        return '';
    }
  }

  _renderBodyCell = ({columnIndex, key, rowIndex, style}) => {
    const rowClass = this._getRowClassName(rowIndex);
    const datum = this._getDatum(rowIndex);
    const status = this._renderFirstRow(columnIndex);

    let output;

    if (rowIndex === 0) {
      output = status;
    } else {
      output = datum.value[status] || '-';
    }

    return (
      <div className={cn('issues-row', 'issues-row-common', rowClass)} key={key} style={style}>
        {output}
      </div>
    )
  }

  _renderLeftSideCell = ({key, rowIndex, style}) => {
    const { setCurrentElement } = this.props;
    const datum = this._getDatum(rowIndex);
    const rowClass = this._getRowClassName(rowIndex);

    const classNames = cn('issues-row-common', rowClass);

    return (
      <IssuesCell
        style={style}
        key={key}
        setCurrentElement={setCurrentElement}
        cellValue={rowIndex === 0 ? '' : datum.label}
        cellData={datum}
        classNames={classNames}
      />
    );
  }
}


// WEBPACK FOOTER //
// ./src/views/Project/TaskHome/IssuesBreakdown/IssuesBreakdown.js